import { FormGroup } from '@angular/forms';

import { PostalResponse } from '@app-model/api';
import { UserResponse } from '@app-model/login';

export class SurchargeField {
  name: string;
  selected: boolean;
}

export class GetProductsRequest {
  dealer: string;
  dealerState: string;
  programId: string;
  vin: string;
  saleDate: string;
  odometer: string;
  inServiceDate: string;
  financeType: string;
  financeAmount: string;
  isAfterSale: string;
  financeTerm: string;
  vehiclePurchaseDate: string;
  programName: string;
  vehicleMake: string;
  vehicleYear: string;
  vehicleModel: string;
  vehicleTrim: string;
  vehicleCondition: string;
  vehicleCost: string;
  vehicleMSRP: string;
  defaultGetProduct: string;
  customerState: string;
  country: string;
  lienholderName: string;
  surcharges: SurchargeField[];
  version: string;
  methodName: string;
  applicationName: string;
  languageCode: string;
  channel: string;
  vendorName: string;
  userName: string;
  password: string;
  customerTaxExempt: boolean;

  constructor(
    dealer: string,
    vin: string,
    saleDate: string,
    ins_date: string,
    isAfterSale: string,
    vp_date: string,
    vehicleCond: string,
    financeType: string,
    year: string,
    make: string,
    model: string,
    trim: string,
    odometer: string,
    country: string = '',
    customerState: string = '',
    dealerState: string = '',
    languageCode: string = '',
    defaultGetProduct: string = null,
    surcharges: SurchargeField[] = [],
    vehicleMSRP: string,
    customerTaxExempt?: boolean
  ) {
    this.dealer = dealer;
    this.vin = vin;
    this.saleDate = saleDate;
    this.inServiceDate = ins_date;
    this.vehiclePurchaseDate = vp_date;
    this.vehicleCondition = vehicleCond;
    this.financeType = financeType;
    this.vehicleMake = make;
    this.vehicleYear = year;
    this.vehicleModel = model;
    this.isAfterSale = isAfterSale;
    this.vehicleTrim = trim;
    this.odometer = odometer;
    this.vehicleMSRP = vehicleMSRP;
    this.country = country;
    this.customerState = customerState;
    this.dealerState = dealerState;
    this.financeTerm = '';
    this.lienholderName = '';
    this.languageCode = languageCode;
    this.defaultGetProduct = defaultGetProduct;
    this.surcharges = surcharges;
    this.customerTaxExempt = customerTaxExempt;
  }

  static setGetProductsRequestByForm(
    form: FormGroup,
    user: UserResponse,
    postal: PostalResponse = new PostalResponse()
  ) {
    const domain = localStorage.getItem('domain') || '';
    const inServiceDate = form.get('inServiceDate')?.value?.formatted || form.get('inServiceDate')?.value || null;
    const vehicleMSRP = domain === 'youroneprotectcom' ? form.get('msrp').value : null;

    return new GetProductsRequest(
      user.cmsDealerNumber,
      form.get('vin').value,
      form.get('saleDate')?.value?.formatted || form.get('saleDate').value,
      inServiceDate,
      form.get('isAfterSale').value,
      form.get('purchaseDate')?.value?.formatted || form.get('purchaseDate').value,
      form.get('vehicleCondition').value,
      form.get('financeType').value,
      form.get('year').value,
      form.get('make').value,
      form.get('model').value,
      form.get('trim').value,
      form.get('odometer').value,
      postal.country,
      postal.stateAbbr,
      user.dealerInfo.dealerState,
      user.languageCode,
      user.defaultGetProduct,
      form.get('surcharges')?.value || null,
      vehicleMSRP,
      form.get('customerTaxExempt') ? form.get('customerTaxExempt').value === 'YES' : null
    );
  }
}
